import { getUser } from '../app-auth';

const requestMiddleware = [];
export function applyRequestMiddleware( fn ) {
    requestMiddleware.push( fn );
}

export default async function fetchWithAuth ( url, options = {} ) {
    const user = await getUser();
    if ( !user ) {
        // if this happens, it means either...
        //  the user doesn't exist in local storage
        //  the user has an access token that expired and refreshing failed
        throw new Error( '¯\\_(ツ)_/¯' );
    }
    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ user.access_token }`,
        'company-id': user.claims.company_id,
        'x-company-id': user.claims.company_id,
        'companyId': user.claims.company_id
    };
    return fetch( url, options );
}
